import { ManufacturingMethodOptions } from '../constants';
import type { ManufacturingMethodType } from '../constants';

/**
 * 各一覧画面への製法区分・備考1〜3表示対応（P-0053）。
 * 設計: docs/sdd/phases/p2-design/design-listing-fields-display.md §3
 */

/**
 * 製法区分の表示文字列を取得する。
 *
 * 通常入札・相対の出品は常に値を持たない（D-0100・INV-LFD-1）ため "-" になる。
 */
export const formatManufacturingMethod = (
  value: ManufacturingMethodType | '' | null | undefined,
): string => {
  if (value === '' || value == null) {
    return '-';
  }
  return ManufacturingMethodOptions.find((opt) => opt.value === value)?.label ?? '-';
};

/**
 * 特記事項(biko)・備考1〜3の結合表示文字列を取得する。
 *
 * 🔒 値がある項目だけを半角スペース付きの `" / "` で連結する（空欄項目は詰めて表示しない・D-0132で
 *   位置保持〔案B〕から変更。例: 備考2だけ値がある場合は備考2の内容だけを返す＝INV-LFD-3）。
 *   全項目が空文字の場合は結合ロジックを発動させず、呼び出し側の既存の空欄表現（`emptyFallback`）を
 *   そのまま返す（INV-LFD-4。画面ごとに "備考なし"／"-" 等が異なるため引数で受け取る）。
 */
export const formatCombinedMemo = (
  biko: string | null | undefined,
  saleBiko1: string | null | undefined,
  saleBiko2: string | null | undefined,
  saleBiko3: string | null | undefined,
  emptyFallback: string,
): string => {
  const parts = [biko, saleBiko1, saleBiko2, saleBiko3].filter(
    (part): part is string => !!part,
  );
  if (parts.length === 0) {
    return emptyFallback;
  }
  return parts.join(' / ');
};

/** 備考(特記事項/備考1〜3)のいずれかに値があるかどうか（条件付き表示の行の出し分けに使う）。 */
export const hasAnyMemo = (
  biko: string | null | undefined,
  saleBiko1: string | null | undefined,
  saleBiko2: string | null | undefined,
  saleBiko3: string | null | undefined,
): boolean => [biko, saleBiko1, saleBiko2, saleBiko3].some((part) => !!part);
